<template>
  <div>
    <Collapse accordion>
      <Panel :name="item.ClassificationID" v-for="item of lists" :key="item.ClassificationID">
        <Avatar :src="item.IconUrl" />
        {{ item.Classification }}
        <div slot="content">
          单位: （{{ item.unit }}）
          <Button type="info" icon="ios-add" @click="NewBuildMainHandleClick(item.ClassificationID)">新增</Button>
          <Collapse accordion>
            <Panel
              :name="item1.Price_rules_ID"
              v-for="item1 of item.Price_rules_main"
              :key="item1.Price_rules_ID"
            >
              {{ item1.Price_rulesName }} （类型：{{item1.type}}） （{{ item1.Remarks }}）
                <List slot="content">
                  <ListItem>
                    <li>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="ios-create-outline"
                          @click="EditMainHandleClick(item1)"
                        >编辑</Button>
                      </li>
                      <li style="margin-left:2rem">
                        <Button
                          type="error"
                          shape="circle"
                          icon="ios-close"
                          @click="DeleteMainHandleClick(item1)"
                        >删除</Button>
                      </li>
                  </ListItem>
                  <ListItem>
                    <Button type="dashed" icon="ios-add" long @click="NewBuildDetailHandleClick(item1)">新增</Button>
                  </ListItem>
                  <ListItem v-for="item2 of item1.Product_Price_rules" :key="item2.index">
                    <ListItemMeta :description="item2.AttributesName" />
                    <!-- <ListItemMeta title="单位" :description="item.unit" /> -->
                    <template slot="action">
                      <li>
                        <Button
                          type="error"
                          shape="circle"
                          icon="ios-close"
                          @click="DeleteDetailHandleClick(item2)"
                        >删除</Button>
                      </li>
                    </template>
                  </ListItem>
                </List>
            </Panel>
          </Collapse>
        </div>
      </Panel>
    </Collapse>
    <Modal
        title="价格规则编辑"
        v-model="ModalShow"
        :loading="isloading"
        @on-ok="SubmitMainHandleClick('formCustom')"
        :closable="false">
        <Form :model="maininfo" label-position="top" ref="formCustom" :rules="ruleCustom">
           <FormItem label="规则ID">
               <Input v-model="maininfo.Price_rules_ID" disabled></Input>
           </FormItem>
           <FormItem label="规则名称" prop="Price_rulesName">
               <Input v-model="maininfo.Price_rulesName"></Input>
           </FormItem>
           <FormItem label="规则类型" prop="type">
               <!-- <Input v-model="maininfo.type"></Input> -->
               <Select v-model="maininfo.type" value="maininfo.type">
                <Option value="产品">产品</Option>
                <Option value="包装">包装</Option>
              </Select>
           </FormItem>
           <FormItem label="备注">
               <Input v-model="maininfo.Remarks"></Input>
           </FormItem>
        </Form>
    </Modal>
    <Modal
        title="价格规则明细编辑"
        v-model="ModalShow1"
        :loading="isloading1"
        @on-ok="SubmitDetailHandleClick('formCustom1')"
        :closable="false">
        <Form :model="detailinfo" label-position="top" ref="formCustom1" :rules="ruleCustom1">
           <FormItem label="规则名称">
               <Input v-model="detailinfo.Price_rulesName" disabled></Input>
           </FormItem>
           <FormItem label="中类ID">
               <Input v-model="detailinfo.AttributesID" disabled></Input>
           </FormItem>
           <FormItem label="中类名称" prop="AttributesName">
               <Select  filterable :label-in-value="true" @on-change="SelectHandle" clearable>
                <Option v-for="item in selectionlist" :value="item.AttributesID" :key="item.AttributesID">{{ item.AttributesName }}</Option>
               </Select>
           </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
import { PriceRulesInfo, ChangePriceRulesMainInfo, ChangePriceRulesDetailInfo, PriceRulesSelectionData } from '../../../api/PriceRules'
export default {
  name: 'PriceRules',
  data () {
    const validatePricerulesName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写规则名称'))
      }
      callback()
    }
    const validatetype = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择产品类型'))
      }
      callback()
    }
    const validateAttributesName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写中类名称'))
      }
      callback()
    }
    return {
      lists: Array,
      selectionlist: Array,
      ModalShow: false,
      isloading: true,
      ModalShow1: false,
      isloading1: true,
      maininfo: {
        Price_rules_ID: '',
        ClassificationID: '',
        Price_rulesName: '',
        type: '',
        Remarks: ''
      },
      detailinfo: {
        Price_rules_ID: '',
        Price_rulesName: '',
        ClassificationID: '',
        AttributesID: '',
        AttributesName: '',
        state: 0,
        type: 1
      },
      State: 0,
      State1: 0,
      ruleCustom: {
        Price_rulesName: [{ validator: validatePricerulesName, trigger: 'blur' }],
        type: [{ validator: validatetype, trigger: 'blur' }]
      },
      ruleCustom1: {
        AttributesName: [{ validator: validateAttributesName, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetMaterialCategoryData()
  },
  methods: {
    //   获取大类数据
    GetMaterialCategoryData () {
      PriceRulesInfo().then(res => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击主表新增触发事件
    NewBuildMainHandleClick (ClassificationID) {
      this.maininfo = {
        Price_rules_ID: '',
        Price_rulesName: '',
        ClassificationID: ClassificationID,
        type: '',
        Remarks: ''
      }
      this.isloading = true
      this.ModalShow = true
      this.State = 0
    },
    // 提交价格规则主表信息确定
    SubmitMainHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isloading = false
          this.ModalShow = false
          // this.$Modal.remove()
          this.OKHandleClick()
        } else {
          this.isloading = true
          setTimeout(() => {
            this.isloading = false
          }, 2000)
          this.$Message.error('Fail!')
        }
      })
    },
    // 更新价格规格主表信息
    OKHandleClick () {
      ChangePriceRulesMainInfo({
        Price_rules_ID: this.maininfo.Price_rules_ID,
        ClassificationID: this.maininfo.ClassificationID,
        Price_rulesName: this.maininfo.Price_rulesName,
        Remarks: this.maininfo.Remarks,
        type: this.maininfo.type,
        Product_Price_rules: [],
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetMaterialCategoryData()
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 编辑价格规则主表信息
    EditMainHandleClick (item) {
      this.maininfo = {
        Price_rules_ID: item.Price_rules_ID,
        ClassificationID: item.ClassificationID,
        Price_rulesName: item.Price_rulesName,
        Remarks: item.Remarks,
        type: item.type,
        Product_Price_rules: [],
        operation: 1
      }
      this.isloading = true
      this.ModalShow = true
      this.State = 1
    },
    // 删除价格规则主表数据
    DeleteMainHandleClick (item) {
      this.maininfo.Price_rules_ID = item.Price_rules_ID
      this.State = 2
      this.$Modal.confirm({
        title: '删除规则',
        content: '<p>确定删除 "' + item.Price_rulesName + '"这条价格规则？</p>',
        onOk: () => {
          this.OKHandleClick()
        }
      })
    },
    // 新增价格规则明细数据
    NewBuildDetailHandleClick (item) {
      let type = 1
      if (item.type === '包装') { type = 2 }
      this.detailinfo = {
        Price_rules_ID: item.Price_rules_ID,
        Price_rulesName: item.Price_rulesName,
        ClassificationID: item.ClassificationID,
        AttributesID: '',
        AttributesName: '',
        state: 0,
        type: type
      }
      this.isloading1 = true
      this.ModalShow1 = true
      this.State1 = 0
      this.GetPriceRulesSelectionData(item.ClassificationID) // 获取下拉数据
    },
    // 提交价格规则明细确认信息
    SubmitDetailHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isloading1 = false
          this.ModalShow1 = false
          // this.$Modal.remove()
          this.OKDetailHandleClick()
        } else {
          this.isloading1 = true
          setTimeout(() => {
            this.isloading1 = false
          }, 2000)
          this.$Message.error('Fail!')
        }
      })
    },
    // 更新价格规则明细信息
    OKDetailHandleClick () {
      ChangePriceRulesDetailInfo({
        index: 0,
        Price_rules_ID: this.detailinfo.Price_rules_ID,
        ClassificationID: this.detailinfo.ClassificationID,
        AttributesID: this.detailinfo.AttributesID,
        AttributesName: this.detailinfo.AttributesName,
        state: this.detailinfo.state,
        type: this.detailinfo.type,
        operation: this.State1
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetMaterialCategoryData()
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 获取价格明细下拉数据
    GetPriceRulesSelectionData (ClassificationID) {
      PriceRulesSelectionData(ClassificationID).then(res => {
        if (res.IsSuccess) {
          this.selectionlist = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 下拉选择后回调
    SelectHandle (value) {
      this.detailinfo.AttributesID = value.value
      this.detailinfo.AttributesName = value.label
    },
    // 删除价格规则明细数据
    DeleteDetailHandleClick (item) {
      this.detailinfo.Price_rules_ID = item.Price_rules_ID
      this.detailinfo.AttributesID = item.AttributesID
      this.State1 = 2
      this.$Modal.confirm({
        title: '删除规则',
        content: '<p>确定删除价格规则中 "' + item.AttributesName + '" 的这个属性吗？</p>',
        onOk: () => {
          this.OKDetailHandleClick()
        }
      })
    }
  }
}
</script>
